import { IFormField } from "../../web-form.objects"
import { JsonItem, PickListItem } from "../../../../entities/pick-list/pick-list.entities";
import _ from "lodash";

export class DropdownInputV1Options {
    isMultiselect: boolean = false;
    isSearchable: boolean = false;
    optionsId: string;
    options: PickListItem[] = undefined;
    sortOptions: boolean = true;
    constructor(optionsId: string = "", isMultiselect: boolean = false, isSearchable: boolean = false, sortOptions: boolean = true) {
        this.optionsId = optionsId;
        this.isMultiselect = isMultiselect;
        this.isSearchable = isSearchable;
        this.sortOptions = sortOptions;
        this.options = undefined;
    }
}

export class DropdownInputFieldV1 implements IFormField {
    fieldId: string;
    displayName: string;
    description: string;
    isRequired: boolean;
    propertyName: string;
    defaultVal: any;
    initialVal: any;

    options: DropdownInputV1Options;

    constructor(propertyName: string, fieldId: string, displayName: string, description: string, isRequired: boolean, options: DropdownInputV1Options = new DropdownInputV1Options()) {
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.description = description;
        this.isRequired = isRequired;
        this.propertyName = propertyName;
        this.options = options;

        if (this.options.optionsId && !this.options.isMultiselect) {
            this.defaultVal = 0;
            this.initialVal = 0;
        }
        else {
            this.defaultVal = "";
            this.initialVal = "";
        }
    }

    generateHtml(): string {
        let requiredClass = "";
        if (this.isRequired) requiredClass = "required";

        let multipleClass = "";
        if (this.options.isMultiselect) multipleClass = "multiple"

        let searchClass = "";
        if (this.options.isSearchable) searchClass = `data-live-search="true"`;

        let html = `
            <label for="" class="${requiredClass}">${this.displayName}</label>
            ${this.description != "" ? `<p class='form-text'>${this.description}</p>` : ``}
            ${this.options.isMultiselect ? `<p class='form-text font-size13 font-italic'>Select all that apply.</p>` : ``}
            <select id="${this.fieldId}" class="selectpicker dropdown connect-form-dropdown" title="None Selected" data-width="100%" data-container="body" data-dropup-auto="false" data-size="5" ${searchClass} ${multipleClass}></select>
        `

        return html;
    }

    initialize() {
        if (this.options.options != undefined) {
            this.generateDropdown();
        }
        else {
            $(`#${this.fieldId}`).selectpicker({
                dropupAuto: false,
                selectedTextFormat: "count",

                countSelectedText: (numSelected, numTotal) => {
                    if (numSelected == numTotal) {
                        return "All";
                    }
                    else {
                        return numSelected + " Selected";
                    }
                }
            });

            $(`#${this.fieldId}`).selectpicker("refresh");
        }

        $(`#${this.fieldId}`).on("changed.bs.select", () => {
            $(`#${this.fieldId}`).trigger("form-field-change");
        });
    }

    setOptions(pickLists: JsonItem[]) {
        let foundList = pickLists.find(list => list.Id == this.options.optionsId)?.Json;
        if (foundList) {
            this.options.options = foundList;
        }
    }

    prepopulate(items: any[]): void {
        this.initialVal = this.defaultVal;
        // Check if all have valid
        let isValid = items.every(item => _.get(item, this.propertyName));

        if (isValid) {
            // Check if all are the same
            if (items.every((item, i, arr) => _.get(item, this.propertyName) == _.get(arr[0], this.propertyName)) && items.length > 0) {
                this.initialVal = _.get(items[0], this.propertyName);
            }
        }

        if (this.options.isMultiselect) {
            this.setMultiselectInput(this.initialVal);
        }
        else {
            this.setSingleInput(this.initialVal);
        }
    }

    updateItem(item: any): any {
        let updatedItem = _.cloneDeep(item);
        _.set(updatedItem, this.propertyName, this.getValue());
        return updatedItem;
    }

    setDisabled(isDisabled: boolean) {
        $(`#${this.fieldId}`).prop("disabled", isDisabled);
        if (this.options.isMultiselect) {
            this.setMultiselectInput('');
        }
        else {
            this.setSingleInput('');
        }
        $(`#${this.fieldId}`).selectpicker("refresh");
    }

    private generateDropdown() {
        $(`#${this.fieldId}`).find("option").remove();
        $(`#${this.fieldId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });

        if (!this.options.isMultiselect) {
            // Add default option with no value to show no input (no favoritism)
            $(`#${this.fieldId}`).append(`<option hidden disabled selected value>-- Select --</option>`);
        }

        if (this.options.sortOptions && this.options.options != undefined) {
            this.options.options.sort((x1, x2) => x1.Value.localeCompare(x2.Value));
        }

        if (this.options.options != undefined) {
            this.options.options.forEach(option => {
                $(`#${this.fieldId}`).append(new Option(option.Value, option.Id.toString(), false, false));
            })
        }

        $(`#${this.fieldId}`).selectpicker("refresh");
    }

    private getInput(): string | string[] {
        if (this.options.isMultiselect) {
            let input = <string[]>$(`#${this.fieldId}`).val();
            return input;
        }
        else {
            let input = <string>$(`#${this.fieldId}`).val();
            return input;
        }
    }

    private setMultiselectInput(data: string) {
        let valArr = data.split("|");
        $(`#${this.fieldId}`).selectpicker("val", valArr);
    }

    private setSingleInput(data: string | number) {
        let strVal = data.toString();
        $(`#${this.fieldId}`).selectpicker("val", strVal);
    }

    private getParsedInput() {
        let val = this.defaultVal;
        let input = this.getInput();
        if (this.options.isMultiselect) {
            val = (<string[]>input).join("|");
        }
        else {
            let stringVal = <string>input;
            let parsedNum = parseInt(stringVal);
            if (parsedNum) {
                val = parsedNum
            }
        }
        return val;
    }

    getValue(): any {
        let val = this.initialVal;

        let isValid = this.checkValid();
        let isChanged = this.checkChanged();
        if (isValid && isChanged) {
            val = this.getParsedInput();
        }

        return val;
    }

    setValue(formData: any) {
        let formVal = _.get(formData, this.propertyName);
        if (formVal != undefined) {
            if (this.options.isMultiselect) {
                this.setMultiselectInput(formVal);
            }
            else {
                this.setSingleInput(formVal);
            }
        }
    }

    checkValid(): boolean {
        if (this.isRequired) {
            let input = this.getParsedInput();
            // empty
            if (!input) {
                return false;
            }
            return true;
        }
        else {
            return true;
        }
    }

    checkChanged(): boolean {
        let val = this.getParsedInput();
        if (val != this.initialVal) {
            return true;
        }
        return false;
    }

    displayValid(isValid: boolean) {
        if (isValid) {
            $(`#${this.fieldId}`).siblings(".dropdown-toggle").addClass("is-valid").removeClass("is-invalid");
        }
        else {
            $(`#${this.fieldId}`).siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
        }
    }

    resetValidDisplay() {
        $(`#${this.fieldId}`).siblings(".dropdown-toggle").removeClass("is-valid").removeClass("is-invalid");
    }

    private getDisplayVal(item: any): string {
        let val = _.get(item, this.propertyName);

        if (!val) val = "";

        if (this.options.isMultiselect && this.options.options) {
            let stringVal = <string>val;
            let valArr = stringVal.split("|");
            let displayOptions: string[] = [];
            valArr.forEach(id => {
                let foundItem = this.options.options.find(x => x.Id.toString() == id);
                if (foundItem) {
                    displayOptions.push(foundItem.Value);
                }
            });

            let listContent: string = "";
            displayOptions.sort();
            displayOptions.forEach(option => {
                listContent += `<li>${option}</li>`
            });
            return `<ul class="pl-2 mb-0">${listContent}</ul>`;
        }
        else if (this.options.options) {
            let display = "";
            let stringVal = <string>val;
            let foundItem = this.options.options.find(x => x.Id.toString() == stringVal);
            if (foundItem) {
                display = foundItem.Value;
            }
            return display;
        }
        else {
            let stringVal = <string>val;
            return stringVal;
        }
    }

    compareItems(item1: any, item2: any): boolean {
        let x1 = _.get(item1, this.propertyName);
        let x2 = _.get(item2, this.propertyName);

        if (!this.options.isMultiselect) {
            return x1 === x2;
        }
        else if (!x1 && !x2) {
            return true; // both null/empty
        }
        else if (!x1 || !x2) {
            return false; // one null/empty other isn't
        }
        else {
            let x1Arr = (<string>x1).split("|");
            let x2Arr = (<string>x2).split("|");
            if (x1Arr.length != x2Arr.length) {
                return false;
            }
            else {
                return x1Arr.sort().join("|") == x2Arr.sort().join("|");
            }
        }
    }

    generateChangeHtml(newItem: any, prevItem: any): string {
        let isChanged = false;

        if (prevItem == undefined) {
            isChanged = true;
        }
        else {
            isChanged = !this.compareItems(newItem, prevItem);
        }

        if (!isChanged) {
            return "";
        }

        let changeContent = "";
        let newVal = _.get(newItem, this.propertyName);
        if (newVal) {
            let newDisplay = `
                    <div class="new-change-block change-block">
                        <div class="col-auto">
                            <i class="fa-solid fa-plus new-change-icon"></i>
                        </div>
                        <div class="col">
                            ${this.getDisplayVal(newItem)}
                        </div>
                    </div>
                `;
            changeContent = newDisplay;
        }

        if (prevItem != undefined) {
            let prevVal = _.get(prevItem, this.propertyName);
            if (prevVal) {
                let prevDisplay = `
                        <div class="delete-change-block change-block">
                            <div class="col-auto">
                                <i class="fa-solid fa-trash-can delete-change-icon"></i>
                            </div>
                            <div class="col">
                                ${this.getDisplayVal(prevItem)}
                            </div>
                        </div>
                    `;
                changeContent += prevDisplay;
            }
        }

        let html = `
                <div class="change-content-block">
                    <div class="change-content-label">
                        ${this.displayName}
                    </div>
                    ${changeContent}
                </div>
            `;

        return html;
    }
}
